import { format } from "date-fns";

// export async function getHarvest(data) {
//     const {token, crop, selectedFromDate, selectedToDate} = data
//     const axios = require("axios")
//     const headers = {
//                 "Authorization" : `Bearer ${token}`,
//                 "Access-Control-Allow-Origin" : "*",
//                 "Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept",
//                 }

//     const cropURI = encodeURIComponent(crop)
//     const fromURI = encodeURIComponent(format(selectedFromDate, "yyyy-MM-dd"))
//     const toURI = encodeURIComponent(format(selectedToDate, "yyyy-MM-dd"))     
//     const url = `/api/v0/data/harvest_report/YILI?crop=${cropURI}&from=${fromURI}&to=${toURI}&csv=true` 
//     const response = await axios.get(url , { headers })
//     return response
// }

export function getHarvest(data) {
    let date = getNow()
    const { harvest } = data || []
    if (harvest) {
        let header = ["Crop", "Harvest on", "Greenhouses", "Total Harvest (kg)", "Remark"]
        let payload = harvest.map((h)=>{
            return [h.Crop, h.Harvest, h.Greenhouses, h.Total, h.Remark]
        })
        return ({filename: `harvest_${date}.csv`, header: header, data:payload})
    }
    return ({filename: `harvest_${date}.csv`, header:[], data:""})
}

export function getEnvironment(data) {
    let date = getNow()
    const {environments} = data || []
    if (environments) {
        let header = ["Timestamp", "Air Temperature", "Air Humidity", 
                        "Soil EC", "Soil Temperature", "Soil Humidity", "Illuminance"]
        let payload = environments.map(
            (env) => {
                return [env.Timestamp, 
                        env.FarmSensor.air_temp, 
                        env.FarmSensor.air_hum, 
                        env.FarmSensor.soil_ec, 
                        env.FarmSensor.soil_temp, 
                        env.FarmSensor.soil_hum,
                        env.FarmSensor.illuminance
                    ]
            }
        )
        return({filename: `environment_${date}.csv`, header: header, data: payload})
        
    }
    return ({filename: `environment_${date}.csv`, header:[], data:""})
}

export function getCultivation(data) {
    let date = getNow()
    const { cults } = data || []
    if (cults) {
        let header = ["plant_date", "harvest_date", "crop", "quantity", "greenhouse_id",
                        "cultivation", "plowing", "Pre-fertilizing", "Pre-Watering",
                        "Apply Agro-Chemical 1", "Apply Agro-Chemical 2","Apply Agro-Chemical 3",
                        "Apply Agro-Chemical 4", "Fertilizing 1", "Fertilizing 2", "Fertilizing 3",
                        "Fertilizing 4", "Harvest"]
    
        let computedHeader = []
        let payload = cults.map(
            (cult) => {
                let buffer= []
                header.forEach((head) => {
                    Object.keys(cult).forEach((key)=> {
                        if (head === key) {
                            if (!computedHeader.includes(key)) {
                                computedHeader.push(key)
                            }
                            buffer.push(cult[key])
                        }
                    })
                })
                return buffer
            }
        )
        return ({filename: `cultivation_report_${date}.csv`, header:computedHeader, data:payload})
    }
    return ({filename:`cultivation_report_${date}.csv`, header:[], data:""})
}

export function getCultivationRecords(data) {
    let date = getNow()
    const { records } = data || []
    if (records) {
        let header = ["operation_id", "plant_date", "harvest_date", "crop", "total", "greenhouse_id",
                        "cultivation", "Pre-fertilizing", "Pre-Watering",
                        "Apply Agro-Chemical 1", "Apply Agro-Chemical 2","Apply Agro-Chemical 3",
                        "Apply Agro-Chemical 4", "Fertilizing 1", "Fertilizing 2", "Fertilizing 3",
                        "Fertilizing 4"]
    
        let computedHeader = []
        let payload = records.map(
            (record) => {
                let buffer= []
                header.forEach((head) => {
                    Object.keys(record).forEach((key)=> {
                        if (head === key) {
                            if (!computedHeader.includes(key)) {
                                computedHeader.push(key)
                            }
                            buffer.push(record[key])
                        }
                    })
                })
                return buffer
            }
        )
        return ({filename: `cultivation_records_${date}.csv`, header:computedHeader, data:payload})
    }
    return ({filename:`cultivation_records_${date}.csv`, header:[], data:""})
}

export function getIrrigation(data) {
    let date = getNow()
    const { irrigation } = data || []
    if (irrigation) {
        let header = ["Date", "Duration (mins)", "Total Comsumption (L)"]
        let payload = irrigation.map((irr)=>{
            return [irr.Date, irr.Duration, irr.Total]
        })
        return ({filename: `irrigation_${date}.csv`, header: header, data: payload})
    }
    return ({filename: `irrigation_${date}.csv`, header: [], data: ""})
}

function getNow() {
    return format(new Date(), "yyyy-MM-dd_HH_mm")
}